/*
    underline-menu
*/
import $ from '../../util/dom-core.js';

// 构造函数
function Import(editor) {
	this.editor = editor;
	this.$elem = $(
		`<div class="w-e-menu i_0"><i id="w-e_link-import" class="w-e-menu_import">导入内容</i></div>`
	);
	this.type = 'click';

	// 当前是否 active 状态
	this._active = false;
}

// 原型
Import.prototype = {
	constructor: Import,

	// 点击事件
	// onClick: function(e) {
	// 	// 点击菜单将触发这里

	// 	const editor = this.editor;
	// 	const isSeleEmpty = editor.selection.isSelectionEmpty();

	// 	if (isSeleEmpty) {
	// 		// 选区是空的，插入并选中一个“空白”
	// 		editor.selection.createEmptyRange();
	// 	}
    //     editor.cmd.do('insertHTML',`<span class="text-dashed">插入了一段文本哈哈安徽安徽安徽安徽安徽安徽啊哈哈<span class="TextRemarks">注</span></span>`);
    //     // if(editor.selection.getRange().commonAncestorContainer.innerHTML == undefined){
    //     //     let oldText = editor.selection.getSelectionText()
    //     //     editor.cmd.do('insertHTML',`<div class="text-dashed"><span>${oldText}</span></div>`);
    //     // }else{
    //     //     let oldText = editor.selection.getRange().commonAncestorContainer.innerHTML
    //     //     editor.cmd.do('insertHTML',`<div class="text-dashed">${oldText}</div>`);
    //     // }
	// 	// 执行 underline 命令
	// 	// editor.cmd.do('increaseFontSize');

	// 	if (isSeleEmpty) {
	// 		// 需要将选取折叠起来
	// 		editor.selection.collapseRange();
	// 		editor.selection.restoreSelection();
	// 	}
	// },

	// 试图改变 active 状态
	// tryChangeActive: function(e) {
	// 	const editor = this.editor;
	// 	const $elem = this.$elem;
	// 	if (editor.cmd.queryCommandState('insertHTML')) {
	// 		this._active = true;
	// 		$elem.addClass('w-e-active');
	// 	} else {
	// 		this._active = false;
	// 		$elem.removeClass('w-e-active');
	// 	}
	// },
};

export default Import;
